var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "h-full"
  }, [_c('Tabs', {
    staticClass: "bg-[#fff] rounded-[8px] shadow-[0_2px_8px_rgba(0,0,0,0.1)]",
    attrs: {
      "name": "invite-tab"
    },
    on: {
      "on-click": _vm.changeTab
    },
    model: {
      value: _vm.activeTab,
      callback: function ($$v) {
        _vm.activeTab = $$v;
      },
      expression: "activeTab"
    }
  }, _vm._l(_vm.tabList, function (item) {
    return _c('TabPane', {
      key: item.name,
      attrs: {
        "label": item.label,
        "name": item.name
      }
    }, [_c(item.component, {
      ref: "inviteRef",
      refInFor: true,
      tag: "component",
      staticClass: "p-[20px]",
      on: {
        "check": _vm.checkInvite
      }
    })], 1);
  }), 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };